import { ApplicantType } from './applicant-type.enum';
export class PortalUser {
    public applicantId: number;
    public applicantName: string;
    public applicantCode: string;
    public applicantType: ApplicantType;
    public userName: string;
}

export function currentUser(): PortalUser {
    return JSON.parse(localStorage.getItem('user'));
} 